<script>
  import {createEventDispatcher} from 'svelte';
  import apps from './stores/AppStore.js';
  const dispatch = createEventDispatcher();
  export let app;
  let formfields = {};
  let error;
  const elementAction = (tag) => {
    if(tag === 'close') return dispatch('elementAction', {tag});
    if(tag === 'save' && app._id) return patchApp();
    if(tag === 'save' && !app._id) return postApp();
  }
  const patchApp = async () => {
    app = {...app, ...formfields};
    const res = await apps.patch(app);
    if(res.ok) return dispatch('elementAction', {tag: 'close'});
    if(!res.ok) error = res.body.message;
  }
  const postApp = async () => {
      app = {...app, ...formfields};
      const res = await apps.post(app);
      if(res.ok) return dispatch('elementAction', {tag: 'app-created', app: res.body});
      if(!res.ok) error = res.body.message;
  }
</script>

<form on:submit|preventDefault={() => elementAction('save')}>
  <div class="field">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">Name</label>
      <div class="control">
        <input class="input" type="text" placeholder="App Name" value={app.title} on:input={e => formfields.title = e.target.value} required>
      </div>
  </div>
  <div class="field">
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label class="label">Description</label>
    <div class="control">
      <textarea class="textarea" placeholder="Description" value={app.description} on:input={e => formfields.description = e.target.value}></textarea>
    </div>
  </div>
  {#if error}
  <div class="field">
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label class="label">Error</label>
    <div class="control">
      <textarea class="textarea is-danger" placeholder="Error" value={error}></textarea>
    </div>
  </div>
  {/if}
  <div class="field is-grouped">
    <p class="control">
      <button class="button is-info" type="submit">Save</button>
    </p>
    <p class="control">
      <button class="button is-light" type="button" on:click={() => elementAction('close')}>Cancel</button>
    </p>
  </div>
</form>